"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var command = {
  id: "command",
  title: {
    en: "Command",
    de: "Kommando"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Command Window"), /*#__PURE__*/_react.default.createElement("p", null, "The Command window is located within the social menu."), /*#__PURE__*/_react.default.createElement("p", null, "These are windows (like slots) that you can register various commands, skills and texts for convenient use."), /*#__PURE__*/_react.default.createElement("p", null, "Ctrl + L_Click on a button to open the edit menu.", /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "Name the button."), /*#__PURE__*/_react.default.createElement("li", null, "Enter commands. You can enter commands 3 at a time. The commands will be applied simultaneously."), /*#__PURE__*/_react.default.createElement("li", null, "Press 'OK' to create the button. It is only usable when registered in quick slots. Another way to use is to R_Click on the slot registered.")))))
  }
};
var _default = command;
exports.default = _default;